import "./ErrorPage.scss";
import sadrobot from "../../assets/sadrobot.png";
import {
  Accordion,
  Anchor,
  Box,
  Center,
  Image,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import {
  IconBuildingStore,
  IconChevronDown,
  IconUserCircle,
} from "@tabler/icons-react";
import { useNoAuth } from "../../hooks/useNoAuth";
import errorbg from "../../assets/error_bg.png";
import { AppRoutes } from "@/constants.ts";

/**
 * Renders the ErrorPage component, which displays a 404 error page with a message and a button to navigate to the login page.
 *
 * @return {JSX.Element} The JSX for the ErrorPage component
 */
const ErrorPage = () => {
  // Register this component as not requiring auth
  useNoAuth("ErrorPage");

  return (
    <Center
      h="100vh"
      w="100vw"
      bg={`url(${errorbg}) no-repeat center center`}
      style={{ backgroundSize: "cover" }}
    >
      <Stack align="center" maw={800} justify="center" gap={8}>
        <Text fw={600} fz={16}>
          You look a little lost...
        </Text>
        <Title fw={700} fz={64} lh={1.2}>
          Ooops! Page not found
        </Title>
        <Text>
          The page you are looking for does not exist. Please try again.
        </Text>
        <Box w={200} m={24}>
          <Image src={sadrobot} alt="robot" />
        </Box>
        <Accordion variant="separated" radius="md">
          <Accordion.Item
            value="client"
            bg={"white"}
            py={16}
            style={{ border: "1px solid rgb(199, 199, 199)" }}
          >
            <Accordion.Control
              icon={<IconUserCircle />}
              chevron={<IconChevronDown />}
            >
              <Text fw={600}>
                I'm a{" "}
                <Text span c={"#E78A00"} fw={800} inherit>
                  Client
                </Text>{" "}
                looking for my Tax Pro's link
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <Text ta="left" fz={14}>
                Reach out to your tax pro for their invite link to get started.
              </Text>
            </Accordion.Panel>
          </Accordion.Item>
          <Accordion.Item
            value="taxpro"
            bg={"white"}
            py={16}
            style={{ border: "1px solid rgb(199, 199, 199)" }}
          >
            <Accordion.Control
              icon={<IconBuildingStore />}
              chevron={<IconChevronDown />}
            >
              <Text fw={600}>
                I'm a{" "}
                <Text span c={"#0077CC"} fw={800} inherit>
                  Tax Pro
                </Text>{" "}
                trying to get started
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <Text ta="left" fz={14}>
                Need to create an account?{" "}
                <Anchor href={AppRoutes.gettingStarted} c={"#0077CC"} inherit>
                  Create your SmartWiz account
                </Anchor>
              </Text>
              <Text ta="left" fz={14}>
                Already have an account?{" "}
                <Anchor href={AppRoutes.login} c={"#0077CC"} inherit>
                  Sign in
                </Anchor>
              </Text>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Stack>
    </Center>
  );
};

export default ErrorPage;
